import classNames from 'classnames/bind';
import { SectionSide } from "./types";
import styles from "./section.pcss";
var cn = classNames.bind(styles);
export var cnSection = function cnSection(_ref) {
  var side = _ref.side;
  return cn('section', side && side !== SectionSide.all && "side--".concat(side));
};
export var toPx = function toPx(value) {
  return value ? "".concat(value, "px") : undefined;
};